var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"mapContainer",staticClass:"l-container__shared-route__map",attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }